import React from "react";
import { RightIcon } from "assets/icons";
import { To, useNavigate } from "react-router-dom";
import styled, { css } from "styled-components";

interface BoardCardProps extends React.HTMLAttributes<HTMLElement> {
  title: string;
  to: To;
}

const BoardCard = ({ title, to, children, ...rest }: BoardCardProps) => {
  const navigate = useNavigate();

  /**
   * @description 더보기 버튼 클릭 이벤트 핸들러
   */
  function onClickShowMore() {
    navigate(to);
  }

  return (
    <CardStyle {...rest}>
      <TitleStyle onClick={onClickShowMore}>
        {title}
        <RightIcon />
      </TitleStyle>
      {children}
    </CardStyle>
  );
};

export default BoardCard;

/* 스타일 */
const CardStyle = styled.section`
  background: ${({ theme }) => theme.color.background.white};
  padding: 3rem;
  border-radius: 3rem;

  display: flex;
  flex-direction: column;
  gap: 2rem;

  ${({ theme }) => css`
    ${theme.media.small} {
      padding: 2.4rem 1.6rem;
      gap: 1rem;
      border-radius: 2rem;
    }
  `}
`;

const TitleStyle = styled.h3`
  display: flex;
  align-items: center;

  font-size: 2.4rem;
  font-weight: ${({ theme }) => theme.fontWeight.semibold};
  line-height: 3.4rem;
  text-transform: uppercase;

  cursor: pointer;

  svg {
    width: 2.4rem;
    height: 2.4rem;
    color: ${({ theme }) => theme.color.icon.secondary};
  }

  ${({ theme }) => css`
    ${theme.media.small} {
      ${theme.typography.body1.semibold}
    }

    svg {
      width: 2rem;
      height: 2rem;
    }
  `}
`;
